import PropTypes from 'prop-types';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import APP from 'constants/app';

const QuickSettingCard = ({ buttonText, description, imageProps, onClick }) => (
  <Box className="w-full flex-row items-center gap-x-4 rounded-4 px-4 py-4 shadow-[0px_0px_10px_0px_rgba(87,87,87,0.2)] dark:border dark:border-neutral-high-200 dark:bg-neutral-low-500 md:max-w-52 md:flex-col md:gap-x-0 md:px-5">
    <Image
      alt={imageProps.alt}
      height={104}
      src={`${APP.LOCAL_IMAGE_PATH}/features/user-settings/${imageProps.src}`}
      width={104}
    />
    <div className="w-full text-center md:text-start">
      <Text
        className="mb-4 text-neutral-high-500 dark:text-neutral-high-100"
        size="size3"
      >
        {description}
      </Text>
      <Button size="size3" type="secondary" full onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  </Box>
);

QuickSettingCard.propTypes = {
  buttonText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageProps: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default QuickSettingCard;
